const it = {
  accountSuspended: "Il tuo account è sospeso.",
  common: {
    appName: "NO VAX LOVE",
    slogan: "Un'unica iscrizione. Tutto incluso.",
    signIn: "Accedi",
    signUp: "Registrati",
    signOut: "Esci",
    email: "Email",
    password: "Password",
    submit: "Continua",
    cancel: "Annulla",
    or: "oppure",
    joinCta: "Unisciti a NO VAX LOVE",
    discoverCta: "Scopri come funziona",
    loading: "Caricamento...",
    language: "Lingua",
  },
  nav: {
    home: "Home",
    features: "Community",
    philosophy: "Filosofia",
    faq: "Domande frequenti",
    login: "Accedi",
    register: "Registrati",
  },
  landing: {
    regionLabel: "Lancio in Italia",
    imagesNote: "Immagini illustrative generate con IA. Non raffigurano iscritti al servizio.",
    languageNote: "Interfaccia in italiano e inglese.",
    trustTools: "Blocco utenti · Segnalazioni · Esame delle segnalazioni",
    locationTitle: "Posizione nel profilo",
    locationBody: "Il profilo usa la città indicata per aiutarti a trovare persone nella tua zona.",
    sharingTitle: "Condivisione a tua scelta",
    sharingBody: "Puoi scegliere se condividere i campi delicati del profilo. Controlla anche ciò che inserisci in testi, foto e messaggi.",
    welcomeNote: "Chi condivide i valori della community è il benvenuto.",
    legalLabel: "Informazioni legali",

    hero: {
      overline: "Una community per adulti",
      title: "Trova chi condivide la tua visione.",
      subtitle:
        "Una community di appuntamenti creata per adulti che condividono una particolare visione riguardo alla vaccinazione COVID-19 e alla libertà personale. Aperta a tutti, inclusi i vaccinati e chi si sente allineato con i suoi valori.",
    },
    what: {
      overline: "Cos'è",
      title: "Un modo elegante di conoscersi.",
      body:
        "NO VAX LOVE è un luogo online sofisticato, dedicato a persone adulte che desiderano incontrare qualcuno con affinità reali. Nessuna aggressività, nessuna politica: solo autenticità, rispetto e connessione.",
    },
    why: {
      overline: "Perché è diverso",
      title: "Compatibilità che va oltre la superficie.",
      items: [
        { title: "Valori condivisi", body: "Le persone iniziano dalla stessa pagina, con più naturalezza." },
        { title: "Rispetto nella community", body: "Strumenti per bloccare utenti e segnalare comportamenti inappropriati." },
        { title: "Nessun livello premium", body: "Un'unica iscrizione. Tutte le funzioni incluse." },
        { title: "Design europeo", body: "Sobrio, elegante e pensato anche per il telefono." },
      ],
    },
    compatibility: {
      overline: "Compatibilità",
      title: "Le connessioni migliori nascono dai valori.",
      body:
        "Il sistema di NO VAX LOVE aiuta a scoprire persone con affinità autentiche: stili di vita, aspettative e visioni sulla libertà personale.",
    },
    membership: {
      overline: "Iscrizione",
      title: "Un'unica iscrizione. Tutto incluso.",
      body:
        "Un’unica iscrizione per usare le funzioni disponibili: mi piace, abbinamenti, ricerca con filtri, compatibilità, messaggi, condivisione di foto e messaggi vocali.",
      cta: "Unisciti a NO VAX LOVE",
    },
    trust: {
      overline: "Fiducia",
      title: "Strumenti per una community rispettosa.",
      body:
        "Puoi bloccare un utente o segnalare un comportamento inappropriato. Le segnalazioni vengono esaminate dal gestore: questi strumenti non certificano l’identità o l’affidabilità delle persone.",
    },
    privacy: {
      overline: "Privacy",
      title: "La tua privacy, le tue scelte.",
      body:
        "Gestisci la visibilità del profilo e le scelte sui dati delicati nelle impostazioni di privacy.",
    },
    how: {
      overline: "Come funziona",
      title: "Tre passi semplici.",
      steps: [
        { title: "Crea il profilo", body: "Racconta chi sei con eleganza e sincerità." },
        { title: "Scopri persone affini", body: "Sfoglia profili scelti in base ai tuoi valori." },
        { title: "Conosci in modo autentico", body: "Scambiate messaggi e conoscetevi con i vostri tempi." },
      ],
    },
    community: {
      overline: "Filosofia",
      title: "Aperta, adulta, rispettosa.",
      body:
        "Tutti sono i benvenuti: le persone vaccinate, chi ha cambiato idea, chiunque si senta allineato con i valori della community. NO VAX LOVE non discrimina.",
    },
    faq: {
      overline: "FAQ",
      title: "Domande frequenti.",
      items: [
        {
          q: "Chi può iscriversi a NO VAX LOVE?",
          a: "Adulti (18+) che si sentono allineati con i valori della community. Nessuno viene escluso in base allo stato vaccinale.",
        },
        {
          q: "Devo dimostrare il mio stato vaccinale?",
          a: "No. Non richiediamo certificati o documenti sanitari. Le informazioni facoltative del profilo e le relative scelte sono spiegate nell’informativa privacy.",
        },
        {
          q: "Ci sono livelli premium?",
          a: "No. Un'unica iscrizione include tutte le funzioni della piattaforma.",
        },
        {
          q: "Come gestite la privacy?",
          a: "Puoi gestire la visibilità del profilo e scegliere se trattare e condividere i campi delicati. Le scelte si modificano nelle impostazioni di privacy; testi liberi, foto e messaggi vanno gestiti separatamente.",
        },
        {
          q: "In quali Paesi è disponibile?",
          a: "Il lancio iniziale è rivolto all’Italia. L’interfaccia è disponibile in italiano e inglese.",
        },
      ],
    },
    finalCta: {
      overline: "Inizia oggi",
      title: "Sei pronto a incontrare persone con la tua stessa visione?",
      body: "Registrazione veloce, elegante, e sempre discreta.",
      cta: "Unisciti a NO VAX LOVE",
    },
    footer: {
      about: "Chi siamo",
      privacy: "Privacy",
      terms: "Termini",
      contact: "Contatti",
      rights: "Tutti i diritti riservati.",
    },
  },
  auth: {
    login: {
      title: "Bentornato.",
      subtitle: "Accedi al tuo account NO VAX LOVE.",
      submit: "Accedi",
      forgot: "Password dimenticata?",
      noAccount: "Non hai un account?",
      register: "Registrati",
    },
    register: {
      title: "Crea il tuo account.",
      subtitle: "Bastano pochi secondi. Discreto e sicuro.",
      submit: "Crea account",
      adult: "Confermo di avere almeno 18 anni.",
      terms: "Iscrivendoti accetti i Termini e la Privacy Policy.",
      have: "Hai già un account?",
      login: "Accedi",
      country: "Paese",
      city: "Città",
    },
    forgot: {
      title: "Recupera la password.",
      subtitle: "Ti invieremo un link per reimpostarla.",
      submit: "Invia link",
      back: "Torna all'accesso",
      sent: "Se l'email è registrata, riceverai un link a breve.",
    },
    reset: {
      title: "Imposta una nuova password.",
      subtitle: "Scegli una password sicura di almeno 8 caratteri.",
      submit: "Aggiorna password",
      success: "Password aggiornata. Puoi accedere ora.",
    },
    verify: {
      title: "Conferma il tuo indirizzo email.",
      subtitle: "Sto verificando il tuo link...",
      success: "Email verificata. Grazie!",
      failure: "Link non valido o scaduto.",
    },
    errors: {
      minPassword: "La password deve avere almeno 8 caratteri.",
      mustBeAdult: "Devi confermare di avere almeno 18 anni.",
    },
  },
  app: {
    nav: {
      discover: "Scopri",
      matches: "Compatibilità",
      likes: "Mi piace",
      messages: "Messaggi",
      profile: "Il mio profilo",
      notifications: "Notifiche",
      settings: "Impostazioni",
    },
    discovery: {
      title: "Scopri",
      subtitle: "Incontra persone che condividono interessi, valori e stile di vita.",
      filtersButton: "Filtri",
      activeFilters: "attivi",
      like: "Mi piace",
      pass: "Passa",
      undoLike: "Annulla mi piace",
      undoPass: "Annulla",
      undoToast: "Annullato",
      likeSent: "Mi piace inviato",
      passDone: "Profilo passato",
      actionError: "Qualcosa è andato storto. Riprova.",
      sortLabel: "Ordina per",
      sort: {
        recommended: "Consigliati",
        most_compatible: "Più compatibili",
        nearby: "Vicini",
        new_here: "Nuovi qui",
        recently_active: "Attivi di recente",
      },
      compatibleShort: "compatibile",
      compatibleLong: "Compatibilità",
      confidenceLearning: "Compatibilità: in fase di apprendimento",
      confidenceLimited: "Compatibilità basata su informazioni limitate",
      whyCompatible: "Perché siete compatibili",
      sharedInterests: "Interessi in comune",
      sharedValues: "Valori in comune",
      sharedTopValues: "Valori principali condivisi",
      sharedGoals: "Entrambi cercate",
      sharedCommunication: "Comunicazione compatibile",
      similarLifestyle: "Stile di vita simile",
      familyAligned: "Prospettiva sulla famiglia allineata",
      sameFaith: "Stessa spiritualità",
      geoNearby: "Geograficamente vicini",
      sharedPerspective: "Prospettiva sulla community condivisa",
      empty: "Nessun profilo corrisponde ai tuoi filtri attuali.",
      broaden: "Allarga la ricerca",
      loadingError: "Non è stato possibile caricare nuovi profili. Riprova.",
      retry: "Riprova",
      km: "km",
      verified: "Identità verificata",
      loadMore: "Carica altri",
      back: "Torna indietro",
      openProfile: "Apri profilo",
      completeProfile: "Completa il tuo profilo",
      completeProfileBody: "Per scoprire persone compatibili, aggiungi qualche informazione al tuo profilo.",
      insufficientCompatData: "Dati insufficienti per una stima precisa.",
      category: {
        exceptional: "Match eccezionale",
        very_compatible: "Molto compatibili",
        strong: "Compatibilità forte",
        good_potential: "Buon potenziale",
        some_common_ground: "Qualche affinità",
        different: "Profili diversi",
      },
      filters: {
        title: "Filtri",
        reset: "Reimposta",
        apply: "Applica",
        age: "Età",
        ageMin: "Min",
        ageMax: "Max",
        distance: "Distanza",
        anywhere: "Ovunque",
        countries: "Paesi",
        cities: "Città",
        countriesPlaceholder: "Aggiungi paesi (separati da virgola)",
        citiesPlaceholder: "Aggiungi città (separate da virgola)",
        interestedIn: "Interessato/a a",
        relationshipGoals: "Cosa cercano",
        verifiedOnly: "Solo identità verificate",
        interests: "Interessi",
        interestsMatch: "Corrispondenza interessi",
        interestsAny: "Almeno uno",
        interestsAll: "Tutti",
        values: "Valori",
        lifestyle: "Stile di vita",
        smoking: "Fumo",
        alcohol: "Alcol",
        pets: "Animali",
        diet: "Alimentazione",
        family: "Famiglia",
        children: "Figli",
        wantsChildren: "Vuole figli",
        openToChildren: "Aperto a chi ha figli",
        religion: "Religione (opzionale)",
        community: "Prospettiva sulla community (opzionale)",
        communityNote: "Filtro opzionale. Disattivato di default. Non esclude nessuno automaticamente.",
        enableCommunity: "Abilita filtro community",
      },
    },
    match: {
      itsAMatch: "È un match!",
      subtitle: "Vi siete piaciuti a vicenda.",
      sendMessage: "Invia un messaggio",
      keepDiscovering: "Continua a scoprire",
      matchedOn: "Match del",
      matchedRecently: "Match recente",
      title: "I miei match",
      subtitleList: "Le persone con cui c'è interesse reciproco.",
      empty: "Ancora nessun match.",
      emptyBody: "Continua a scoprire persone: quando entrambi vi mettete Mi piace, apparirà qui.",
      detailTitle: "Match",
      messagingComingSoon: "La messaggistica arriverà presto",
      messagingBody: "Presto potrai chattare direttamente con questa persona. Nel frattempo, dai un'occhiata al suo profilo.",
      viewProfile: "Vedi profilo",
    },
    likes: {
      title: "Mi piace inviati",
      subtitle: "Le persone a cui hai messo Mi piace.",
      empty: "Non hai ancora inviato nessun Mi piace.",
      isMatch: "Match!",
      waiting: "In attesa",
      openMatch: "Apri match",
    },
    messaging: {
      inboxTitle: "Messaggi",
      inboxSubtitle: "Le tue conversazioni con i match.",
      inboxEmpty: "Nessuna conversazione ancora.",
      inboxEmptyBody: "Quando invii un messaggio a un match, apparirà qui.",
      placeholder: "Scrivi un messaggio...",
      send: "Invia",
      charsLeft: "{n} caratteri rimasti",
      you: "Tu",
      matched: "Match",
      delivered: "Consegnato",
      readAt: "Letto",
      rateLimited: "Hai inviato troppi messaggi. Attendi un attimo.",
      sendError: "Impossibile inviare il messaggio. Riprova.",
      loadingError: "Impossibile caricare i messaggi.",
      newMessageNotif: "Nuovo messaggio da {name}",
      today: "Oggi",
      yesterday: "Ieri",
      // media + reactions
      photo: "Foto",
      voiceMessage: "Messaggio vocale",
      attachPhoto: "Allega foto",
      recordVoice: "Registra messaggio vocale",
      startRecording: "Tocca per iniziare la registrazione",
      recording: "Registrazione...",
      cancel: "Annulla",
      stop: "Ferma",
      previewPhoto: "Anteprima",
      photoTooLarge: "L'immagine è troppo grande (max 10 MB).",
      voiceTooLarge: "L'audio è troppo grande (max 8 MB).",
      unsupportedType: "Tipo di file non supportato.",
      micDenied: "Permesso microfono negato. Attivalo dalle impostazioni del browser.",
      micUnavailable: "Il microfono non è disponibile in questo browser.",
      reactHeart: "Metti mi piace al messaggio",
      removeReaction: "Rimuovi il cuoricino",
    },
    moderation: {
      overflowMenu: "Altro",
      block: "Blocca",
      report: "Segnala",
      unblock: "Sblocca",
      blockConfirmTitle: "Vuoi bloccare questa persona?",
      blockConfirmBody: "Non potrete più vedervi, mettervi Mi piace o scrivervi. La persona non riceverà una notifica.",
      blockConfirmCta: "Blocca",
      blockDone: "Persona bloccata",
      unblockDone: "Persona sbloccata",
      cancel: "Annulla",
      reportTitle: "Segnala questa persona",
      reportBody: "Ci aiuti a mantenere la community sicura. Scegli un motivo.",
      reportReasonLabel: "Motivo",
      reportDescLabel: "Descrizione (opzionale)",
      reportDescPlaceholder: "Aggiungi dettagli, se vuoi.",
      reportSubmit: "Invia segnalazione",
      reportDone: "Segnalazione inviata. Grazie.",
      reportError: "Impossibile inviare la segnalazione. Riprova.",
      reportDuplicate: "Hai già segnalato questa persona di recente.",
      reasons: {
        harassment: "Molestie",
        spam: "Spam",
        fake_profile: "Profilo falso",
        scam: "Truffa",
        inappropriate_content: "Contenuti inappropriati",
        other: "Altro",
      },
      blockedListTitle: "Utenti bloccati",
      blockedListEmpty: "Non hai bloccato nessuno.",
      blockedListSubtitle: "Le persone che hai bloccato non possono vederti, scriverti o mettersi in contatto con te.",
      blockedSince: "Bloccato il {date}",
      unblockConfirmTitle: "Vuoi sbloccare questa persona?",
      unblockConfirmBody: "Potrete di nuovo vedervi nella scoperta ma i vecchi Mi piace e i vecchi match rimossi non verranno ripristinati automaticamente.",
      unblockConfirmCta: "Sblocca",
      loading: "Caricamento...",
      loadError: "Impossibile caricare l'elenco.",
    },
    account: {
      section: "Account e privacy",
      privacyTitle: "Privacy e dati",
      privacySubtitle: "Gestisci i tuoi dati personali, scarica una copia o richiedi la cancellazione dell'account.",
      exportTitle: "Scarica i miei dati",
      exportBody: "Scarica un file JSON con una copia dei tuoi dati personali (profilo, messaggi, match, segnalazioni, preferenze).",
      exportCta: "Scarica JSON",
      exportError: "Impossibile generare l'export. Riprova.",
      deleteTitle: "Elimina account",
      deleteSubtitle: "Elimina definitivamente il tuo account e i tuoi dati personali.",
      deleteCta: "Elimina account",
      deletePageTitle: "Elimina il tuo account",
      deleteWarningTitle: "Prima di procedere",
      deleteWarningBullets: [
        "Il tuo account entrerà in un periodo di grazia di 30 giorni.",
        "Durante questo periodo non potrai accedere normalmente e il tuo profilo non sarà visibile.",
        "Puoi annullare la cancellazione accedendo di nuovo con email e password entro 30 giorni.",
        "Trascorsi i 30 giorni i tuoi dati personali (profilo, foto, messaggi, preferenze) verranno eliminati o anonimizzati in modo permanente.",
        "Alcuni dati potrebbero essere conservati per obblighi legali, di sicurezza o audit.",
      ],
      passwordConfirmLabel: "Conferma la tua password",
      typedConfirmLabel: "Scrivi ELIMINA per confermare",
      typedConfirmValue: "ELIMINA",
      typedConfirmHint: "Digita esattamente ELIMINA (in maiuscolo).",
      deleteReasonLabel: "Motivo (facoltativo)",
      deleteReasonPlaceholder: "Cosa ti spinge a lasciarci?",
      deleteSubmit: "Elimina definitivamente",
      deleteScheduledTitle: "Cancellazione programmata",
      deleteScheduledBody: "Il tuo account verrà eliminato il {date}. Puoi annullare in qualsiasi momento accedendo di nuovo.",
      cancelDeletion: "Annulla la cancellazione",
      deletionError: "Impossibile completare l'operazione.",
      invalidConfirmation: "La parola di conferma non è corretta.",
      invalidPassword: "Password non corretta.",
      recovery: {
        title: "Il tuo account è in fase di cancellazione",
        body: "Hai richiesto la cancellazione del tuo account. Se cambi idea, accedi con la tua email e password per annullare l'operazione. Trascorsi i 30 giorni, i dati verranno rimossi definitivamente.",
        reactivateCta: "Riattiva il mio account",
        emailLabel: "Email",
        passwordLabel: "Password",
        scheduledOn: "Cancellazione prevista per il {date}",
        success: "Account riattivato. Puoi accedere normalmente.",
        invalidCredentials: "Email o password non corretti.",
        notPendingDeletion: "Questo account non è in fase di cancellazione.",
      },
    },
    legal: {
      privacyTitle: "Informativa sulla privacy",
      termsTitle: "Termini di servizio",
      cookiesTitle: "Cookie policy",
      lastUpdated: "Ultimo aggiornamento: {date}",
      placeholderBadge: "Bozza in revisione",
      draftNotice: "Documento in revisione: alcune informazioni e procedure devono ancora essere completate prima della versione definitiva.",
      backHome: "Torna alla home",
      privacy: {
        intro: "NO VAX LOVE gestisce dati personali per fornire un servizio di appuntamenti online agli adulti residenti in Europa. Questo documento descrive quali dati raccogliamo, perché e per quanto tempo.",
        sections: [
          { title: "1. Chi siamo", body: "Il titolare del trattamento è GD8 srls, con sede in Via Aurelia, 103 — 19034 Luni (SP), Italia. Partita IVA: IT01512650118. Email: info@gd8.it." },
          { title: "2. Dati che raccogliamo", body: "Account (email, password cifrata, lingua), profilo (nome mostrato, età, interessi, foto, valori, preferenze), interazioni (mi piace, match, messaggi, blocchi, segnalazioni), dati tecnici (indirizzo IP, log di sicurezza), dati di pagamento (elaborati da Stripe, non conserviamo i numeri di carta)." },
          { title: "3. Basi giuridiche", body: "Esecuzione del contratto (art. 6.1.b GDPR) per l'erogazione del servizio; consenso (art. 6.1.a) per comunicazioni facoltative; legittimo interesse (art. 6.1.f) per sicurezza e prevenzione frodi." },
          { title: "4. Come usiamo i dati", body: "Per far funzionare la piattaforma, mostrare profili compatibili, garantire la sicurezza della community, rispondere a segnalazioni, elaborare i pagamenti e adempiere a obblighi legali." },
          { title: "5. Conservazione", body: "[PLACEHOLDER — calendario di retention definitivo. Bozza attuale: dati profilo cancellati o anonimizzati entro 30 giorni dalla richiesta di cancellazione; log di sicurezza conservati fino a 12 mesi; dati fiscali conservati per il tempo previsto dalla normativa fiscale.]" },
          { title: "6. Condivisione con terzi", body: "Fornitori tecnici essenziali: Stripe (pagamenti), fornitore di object storage per foto e allegati, provider di email transazionale. Non vendiamo i tuoi dati." },
          { title: "7. Trasferimenti extra-UE", body: "[PLACEHOLDER — indicare eventuali trasferimenti e clausole contrattuali standard.]" },
          { title: "8. I tuoi diritti", body: "Puoi esercitare i diritti previsti dagli articoli 15-22 GDPR: accesso, rettifica, cancellazione, portabilità, opposizione, limitazione. Dall'app puoi scaricare un export dei tuoi dati e richiedere la cancellazione dell'account." },
          { title: "9. Contatti", body: "Per informazioni sul trattamento dei dati personali e per esercitare i tuoi diritti, puoi contattare GD8 srls all’indirizzo email info@gd8.it." },
        ],
      },
      terms: {
        intro: "Utilizzando NO VAX LOVE accetti le condizioni descritte in questo documento. Se non le accetti, ti chiediamo di non utilizzare il servizio.",
        sections: [
          { title: "1. Chi può iscriversi", body: "NO VAX LOVE è riservata agli adulti con almeno 18 anni. Non permettiamo la registrazione a minori." },
          { title: "2. Comportamento della community", body: "Sono vietati contenuti illegali, molestie, spam, profili falsi, truffe, contenuti sessuali non consenzienti e comportamenti aggressivi. Gli utenti che infrangono le regole possono essere sospesi o rimossi." },
          { title: "3. Contenuti degli utenti", body: "Sei responsabile dei contenuti che pubblichi (foto, testi, messaggi vocali). Concedi a NO VAX LOVE una licenza non esclusiva, limitata al funzionamento del servizio, per ospitare e mostrare tali contenuti." },
          { title: "4. Iscrizione e pagamenti", body: "[PLACEHOLDER — condizioni economiche, rinnovo automatico, diritto di recesso ai sensi della normativa europea sui contratti a distanza.]" },
          { title: "5. Sospensione e cancellazione", body: "Ci riserviamo il diritto di sospendere o rimuovere account che violino i termini. Puoi cancellare il tuo account in qualsiasi momento dall'area impostazioni." },
          { title: "6. Limitazione di responsabilità", body: "[PLACEHOLDER — clausole standard di limitazione entro i limiti consentiti dalla legge europea.]" },
          { title: "7. Legge applicabile e foro competente", body: "[PLACEHOLDER — legge applicabile e foro competente per gli utenti consumatori europei.]" },
          { title: "8. Modifiche ai termini", body: "Aggiornamenti sostanziali verranno comunicati con congruo preavviso tramite email o notifica in-app." },
        ],
      },
      cookies: {
        intro: "Utilizziamo cookie di autenticazione e memorizzazioni nel browser per le funzioni richieste e le preferenze. Questa pagina ne descrive scopi, durata e gestione.",
        sections: [
          {
                    "title": "Gestore e contatti",
                    "body": "Il servizio è gestito da GD8 srls, Via Aurelia 103, 19034 Luni (SP), Italia, P. IVA IT01512650118. Per informazioni: info@gd8.it."
          },
          {
                    "title": "Cookie di autenticazione",
                    "body": "L’API di NOVAXLOVE usa access_token (15 minuti dall’emissione, rinnovabile) e refresh_token (7 giorni dall’emissione) per autenticare le richieste e mantenere l’accesso. Sono cookie Secure e HttpOnly. La disconnessione li rimuove; bloccarli può impedire l’accesso."
          },
          {
                    "title": "Preferenze conservate nel browser",
                    "body": "Nel localStorage dell’app, nvl.language ricorda la lingua e nvl.cookies.acknowledged ricorda la chiusura dell’avviso: non hanno una scadenza automatica e rimangono fino alla cancellazione dei dati del sito. Nel sessionStorage, nvl.discovery.filters.<utente> ricorda i filtri e nvl.discovery.sort l’ordinamento; durano per la sessione della scheda, salvo ripristino della sessione da parte del browser."
          },
          {
                    "title": "Analisi e pubblicità",
                    "body": "Non utilizziamo strumenti di analisi delle visite, registrazione delle sessioni o tracciamento pubblicitario. Il pulsante “Ho capito” chiude un avviso informativo e non autorizza finalità ulteriori."
          },
          {
                    "title": "Risorse e pagamenti esterni",
                    "body": "L’interfaccia carica caratteri da Google Fonts e immagini da Unsplash e Pexels: queste richieste comunicano informazioni di connessione ai rispettivi server e non equivalgono, da sole, a cookie. Le pagine di pagamento Stripe o PayPal aperte su richiesta dell’utente sono soggette anche alle informative dei rispettivi gestori. Consulta l’informativa privacy per gli altri trattamenti."
          },
          {
                    "title": "Gestione e aggiornamenti",
                    "body": "Puoi cancellare cookie e dati del sito dalle impostazioni del browser: potresti dover accedere nuovamente e reimpostare le preferenze. Se saranno introdotti strumenti facoltativi, l’informativa e le scelte disponibili saranno aggiornate prima della loro attivazione, acquisendo il consenso quando necessario."
          }
],
        banner: {
          message: "Utilizziamo solo cookie tecnici strettamente necessari al funzionamento del servizio. Consulta la nostra cookie policy per maggiori informazioni.",
          accept: "Ho capito",
          moreInfo: "Cookie policy",
        },
      },
    },
    admin: {
      nav: {
        moderation: "Moderazione",
        auditLog: "Audit log",
        billing: "Prezzi",
      },
      billing: {
        title: "Configurazione prezzi",
        subtitle: "Gestisci fase promozionale, prezzi e disponibilità piani.",
        phaseLabel: "Fase selezionata",
        launchStartHelp: "Il lancio gratuito comincia con l’apertura al pubblico dell’app. Le date di fine gratuità e della promozione restano modificabili: cambiando l’inizio della promozione si aggiorna anche l’ultimo giorno gratuito, e viceversa.",
        invalidCalendar: "Indica un inizio della promozione e una fine non precedente all’inizio. Per il passaggio automatico alle tariffe standard servono entrambe le date.",
        phase: {
          free_launch: "Lancio gratuito",
          promotional: "Prezzi promozionali",
          standard: "Prezzi standard",
        },
        promoDates: "Calendario dei prezzi promozionali",
        promoStart: "Primo giorno promozionale",
        promoEnd: "Ultimo giorno promozionale (incluso)",
        autoStandard: "Passa automaticamente alle tariffe standard dopo la promozione",
        standardFrom: "Tariffe standard dal",
        calendarHelp: "Le date seguono l’orario italiano. Il giorno finale è incluso per intero. Con il passaggio automatico, la promozione inizia il giorno dopo la fine della gratuità, anche se selezioni Prezzi promozionali prima di quella data.",
        noAutomaticCharge: "Il calendario cambia le offerte disponibili: non addebita gli account gratuiti e non modifica gli abbonamenti già acquistati.",
        freeLaunchEndsAt: "Ultimo giorno gratuito (incluso)",
        autoAdvance: "Passa automaticamente a promozionale allo scadere del periodo gratuito",
        pricesTitle: "Prezzi (centesimi €)",
        promotional: "Promozionale",
        standard: "Standard",
        monthly: "Mensile",
        sixMonth: "6 mesi",
        yearly: "12 mesi",
        currency: "Valuta",
        save: "Salva configurazione",
        saved: "Configurazione salvata.",
        error: "Impossibile salvare.",
      },
      moderation: {
        title: "Coda di moderazione",
        subtitle: "Rivedi le segnalazioni della community e applica le azioni necessarie.",
        empty: "Nessuna segnalazione da rivedere.",
        loadError: "Impossibile caricare le segnalazioni.",
        filters: {
          status: "Stato",
          reason: "Motivo",
          all: "Tutti",
        },
        table: {
          reported: "Segnalato",
          reason: "Motivo",
          status: "Stato",
          createdAt: "Data",
          action: "Azione",
          open: "Apri",
          hasMessage: "Con contesto messaggio",
        },
        status: {
          pending: "In attesa",
          reviewing: "In revisione",
          resolved: "Risolta",
          dismissed: "Rigettata",
        },
        action: {
          restore: "Riattiva account sospeso",
          no_action: "Nessuna azione",
          warning: "Avviso",
          suspend: "Sospendi",
          ban: "Bandisci",
          remove_content: "Rimuovi contenuto",
        },
        detail: {
          title: "Dettaglio segnalazione",
          reporter: "Segnalante",
          reported: "Utente segnalato",
          reason: "Motivo",
          description: "Descrizione",
          matchContext: "Match correlato",
          messageContext: "Messaggio correlato",
          adminNotesLabel: "Note interne (solo admin)",
          adminNotesPlaceholder: "Note visibili solo agli amministratori.",
          statusLabel: "Stato",
          actionLabel: "Azione di moderazione",
          actionReasonLabel: "Motivazione dell'azione",
          save: "Salva modifiche",
          saved: "Modifiche salvate.",
          saveError: "Impossibile salvare le modifiche.",
          noMessageContext: "Nessun messaggio correlato",
          noAction: "Nessuna azione applicata",
          currentAction: "Azione corrente",
        },
      },
      audit: {
        title: "Audit log",
        subtitle: "Tutte le azioni sensibili degli amministratori.",
        empty: "Nessuna voce di audit.",
        columns: {
          when: "Quando",
          admin: "Admin",
          action: "Azione",
          target: "Bersaglio",
          details: "Dettagli",
        },
      },
    },
    notifications: {
      title: "Notifiche",
      empty: "Nessuna notifica.",
      markAllRead: "Segna tutte come lette",
      likeFrom: "{name} ti ha messo Mi piace",
      matchWith: "Nuovo match con {name}",
      newMessageFrom: "Nuovo messaggio da {name}",
      justNow: "Adesso",
      minutesAgo: "{n} minuti fa",
      hoursAgo: "{n} ore fa",
      daysAgo: "{n} giorni fa",
      unreadBadge: "non lette",
    },
    comingSoon: {
      badge: "In arrivo",
      title: "Presto disponibile.",
      body: "Stiamo rifinendo questa sezione. Presto potrai usarla da qui.",
    },
    profile: {
      title: "Il mio profilo",
      accountId: "ID account",
      language: "Lingua preferita",
      country: "Paese",
      city: "Città",
      role: "Ruolo",
      status: "Stato account",
      emailVerified: "Email verificata",
      membership: "Iscrizione",
      complete: "Profilo completo",
    },
    settings: {
      title: "Impostazioni",
      language: "Lingua",
      logout: "Esci",
    },
  },
};

export default it;
